( function( $ ) {
  if ( $( '.__gallery_slider' ).length > 0  ) {
    $( '.__slider' ).slick( {
      slidesToShow   : 1,
      slidesToScroll : 1,
      asNavFor       : '.__slider_thumb',
      prevArrow      : false,
      nextArrow      : false,
      adaptiveHeight : true
    } );

    $( '.__slider_thumb' ).slick( {
      slidesToShow   : 10,
      slidesToScroll : 1,
      asNavFor       : '.__slider',
      focusOnSelect  : true,
      prevArrow      : '<button type="button" class="slick-prev"><img src="'+ localized_obj.dir +'/assets/images/arrow-left.png" alt="Previous"></button>',
      nextArrow      : '<button type="button" class="slick-next"><img src="'+ localized_obj.dir +'/assets/images/arrow-right.png" alt="Next"></button>',
      responsive: [
        {
          breakpoint: 1051,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 751,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 551,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 351,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
      ]
    } );

    /* Refresh the thumbnails to fit the size in the browser */
    $( window ).on( 'resize', function() {
      $('.__slider')[0].slick.refresh();
      $('.__slider_thumb')[0].slick.refresh();
    } );
  }
} ) ( jQuery );